import { Controller, useFormContext } from "react-hook-form";
import { usePractice } from "../usePractice";
import { getBrand } from "../utils/brand";

import PhoneInput from "react-phone-number-input/input";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

function PhoneField({
  name,
  label,
  required,
  requiredText = "This field is required",
  validation,
  showSMSConsent = false,
}) {
  const { practice } = usePractice();
  const brand = getBrand(practice?.fields?.brand);
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const rules = {
    ...(required && { required: requiredText }),
    // "Required" alone let truncated numbers like "+12037005" through, which
    // Shopify and Zendesk then reject. Empty optional fields still pass.
    validate: (value) => {
      if (value && !isPossiblePhoneNumber(value)) {
        return "Please enter a complete phone number";
      }
      return validation ? validation(value) : true;
    },
  };
  return (
    <fieldset>
      <label>
        {label}
        {!required && <span className="label-optional"> (Optional)</span>}
      </label>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <PhoneInput country="US" international={true} {...field} />
        )}
      />
      {showSMSConsent && (
        <div className="sms-note">
          <Controller
            name="smsConsent"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <input type="checkbox" id="smsConsent" {...field} />
            )}
          />
          <label htmlFor="smsConsent">
            By checking this box, you agree to receive text messages from{" "}
            {brand.name} for customer care, delivery, and account updates.
            Messages frequency may vary. Message and data rates may apply. Reply
            STOP to opt-out.
          </label>
        </div>
      )}
      <span className="input-error">{errors[name]?.message}</span>
    </fieldset>
  );
}

export default PhoneField;
